export default __webpack_public_path__ + "static/idexModels-77c9c9c9bfc18cf1b7f7c69201443bc1.png";